(function () {
  function parseRating(text) {
    // "4.8 out of 5 stars" -> "4.8"
    var m = (text || "").match(/^([\d.,]+)/);
    return m ? m[1].replace(",", ".") : null;
  }

  function updateFromYotpo() {
    const bar = document.querySelector(".announcement-bar--static");
    if (!bar) return false;

    const countTarget = bar.querySelector("[data-ab-count]");
    const ratingTarget = bar.querySelector("[data-ab-rating]");
    if (!countTarget && !ratingTarget) return false;

    let didCount = false;
    let didRating = false;

    if (countTarget) {
      const yotpoCountEl = document.querySelector("span.reviews-bottomline-total-reviews");
      if (yotpoCountEl) {
        const text = (yotpoCountEl.textContent || "").trim(); // "2139 reviews"
        const digits = text.replace(/\D+/g, "");              // "2139"
        if (digits) {
          countTarget.textContent = digits;
          didCount = true;
        }
      }
    } else {
      didCount = true; // niets te doen, telt niet als "nog wachten"
    }

    if (ratingTarget) {
      const ratingEl = document.querySelector(".yotpo-star-ratings [aria-label]");
      if (ratingEl) {
        const rating = parseRating(ratingEl.getAttribute("aria-label"));
        if (rating) {
          ratingTarget.textContent = rating;
          didRating = true;
        }
      }
    } else {
      didRating = true;
    }

    return didCount && didRating;
  }

  // Probeer direct + luister op late Yotpo inject
  function init() {
    if (updateFromYotpo()) return;

    const obs = new MutationObserver(function () {
      if (updateFromYotpo()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener("load", function () {
      updateFromYotpo();
    });

    // Yotpo's eigen widget-scan kan de pas dynamisch toegevoegde SEO-div soms
    // pas na een korte vertraging verwerken; nog een paar keer proberen als backstop.
    let attempts = 0;
    const interval = setInterval(function () {
      attempts += 1;
      if (updateFromYotpo() || attempts > 10) {
        clearInterval(interval);
      }
    }, 1000);
  }

  init();
})();
